"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryChunkPersistence = void 0;
class InMemoryChunkPersistence {
    constructor() {
        this.chunks = new Map();
    }
    async loadChunk(chunkPos) {
        return this.chunks.get(chunkPos.asMapKey()) || null;
    }
    async persistChunk(chunk) {
        this.chunks.set(chunk.chunkPosition.asMapKey(), chunk);
    }
}
exports.InMemoryChunkPersistence = InMemoryChunkPersistence;
//# sourceMappingURL=InMemoryChunkPersistence.js.map